<template>
  <div
    class="import-sheet"
    :class="{'blur': isContentBlurred}"
    @mouseenter="handleHoverSlideTabsContent()"
    @mouseleave="handleLeaveSlideTabsContent()"
  >
    <a
      class="button-import-spreadsheet cursor-pointer text-primary-90 text-primary-100:hover"
      @click="importFile()"
      :class="{
        'text-base-60 text-base-60:hover cursor-not-allowed disabled': isDisableWhenNotOwner
      }"
    ><i class="fas fa-upload mr-1"></i> {{ $i18nPresenter.t('Import spreadsheet') }}</a>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import util from '@/util'
import EventBus from '@/eventBus'
import eventCategories from '@/constant/eventCategories'

export default {
  data() {
    return {
      isContentBlurred: false,
      eventBusName: 'ai-side-left: isContentBlurred',
    }
  },
  computed: {
    ...mapState({
      slideGenerator: (state) => state.slideGenerator,
    }),
    ...mapGetters(['isDisableWhenNotOwner']),
    hasInputPrompt() {
      return this.slideGenerator.isAIPromptHasInput
    },
  },
  watch: {
    hasInputPrompt() {
      this.isContentBlurred = this.hasInputPrompt
    },
  },
  mounted() {
    EventBus.$on(this.eventBusName, (value) => {
      this.isContentBlurred = value
    })
  },
  destroyed() {
    EventBus.$off(this.eventBusName)
  },
  methods: {
    ...mapActions(['setIsAIPromptHasInputAction']),
    importFile() {
      if (this.$store.state.isDisableEditPresentation) return
      this.$store.state.openModalImportSheet = true
      util.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Import Sheet File > Click Import',
      )
    },
    handleHoverSlideTabsContent() {
      if (!this.hasInputPrompt) return
      this.isContentBlurred = false
      EventBus.$emit(this.eventBusName, false)
    },
    handleLeaveSlideTabsContent() {
      if (!this.hasInputPrompt) return
      this.isContentBlurred = true
      EventBus.$emit(this.eventBusName, true)
    },
  },
}
</script>

<style lang="scss" scoped>
.button-import-spreadsheet{
  &:hover{
    color: rgba(175, 175, 175, var(--tw-text-opacity));
  }
}
.import-sheet {
  width: 100%;
  text-align: center;
  padding: 10px;
  background-color: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  overflow: hidden;
  &.blur {
    position: relative;
    transition: 0.2s ease;
    &::after {
      content: "";
      background-color: rgba(255,255,255,0.5);
      width: 95%;
      height: 40px;
      display: block;
      position: absolute;
      z-index: 1;
      top: 0;
    }
  }
}
</style>
